import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { fmtDate } from "@/components/erp/ErpUi";
import { useWaMsg, waUrl } from "@/lib/waTemplates";
import { toast } from "sonner";
import { Battery, MessageCircle, Check } from "lucide-react";

export function PartReminders({ onCount }) {
  const [list, setList] = useState([]);
  const waMsg = useWaMsg();
  const load = () => api.get("/crm/part-reminders").then(({ data }) => { setList(data); onCount?.(data.length); }).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const done = async (id) => { try { await api.post(`/crm/part-reminders/${id}/done`); toast.success("Marcado como feito"); load(); } catch (e) { toast.error(formatApiError(e)); } };
  if (!list.length) { return null; }
  return (
    <section data-testid="rem-parts" className="rounded-2xl border border-card2-border bg-card2 p-4">
      <div className="flex items-center gap-2 mb-3 text-xs font-mono-caps text-zinc-400 uppercase"><Battery className="h-4 w-4" /> Vencimento de peça <span className="text-zinc-600">· {list.length}</span></div>
      <ul className="space-y-2">
        {list.map((it) => {
          const due = [it.due_date && fmtDate(it.due_date), it.due_km && `${Number(it.due_km).toLocaleString("pt-BR")} km`].filter(Boolean).join(" ou ");
          const msg = waMsg("part_due", { cliente: it.customer_name, peca: it.part, modelo: it.vehicle, veiculo: it.vehicle, placa: it.plate, data: due });
          const href = waUrl(it.phone, msg);
          return (
            <li key={it.id} data-testid={`rem-part-${it.id}`} className="flex items-start gap-3 rounded-xl border border-zinc-800 bg-zinc-900/40 p-3">
              <div className="flex-1 min-w-0">
                <Link to={`/owner/customers/${it.customer_id}/crm`} className="text-sm font-bold text-zinc-100 hover:text-green-neon">{it.customer_name || "—"}</Link>
                <div className="text-[11px] text-zinc-500 mt-0.5"><span className="text-amber-300 font-semibold">{it.part}</span> · {it.vehicle} <span className="font-mono text-zinc-400">{it.plate}</span> · vence {due} · OS #{it.order_number}</div>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                {href && <a data-testid={`rem-part-wa-${it.id}`} href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 h-8 px-2 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold uppercase"><MessageCircle className="h-3.5 w-3.5" /> WhatsApp</a>}
                <button type="button" data-testid={`rem-part-done-${it.id}`} onClick={() => done(it.id)} className="inline-flex items-center gap-1 h-8 px-2 rounded-md border border-zinc-800 bg-zinc-900 text-zinc-200 text-xs hover:bg-zinc-800"><Check className="h-3.5 w-3.5" /> Feito</button>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
